<template>
    <div class="container container--destockage">

        <Loader v-if="!isReady"></Loader>
            
        <List v-else class="list--products"
            :filtering="this"
            :itemNameSingular="'article'"
            :itemNamePlural="'articles'" >

            <template v-slot:actions>
                    
                <Button 
                    class=".native"
                    :disabled="!hasContent"
                    :loading="processingXlsx"
                    @click.native="downloadXlsx">
                    <span class="fa fa-file-excel-o"></span>
                    Télécharger
                </Button>
            
            </template>

            <template v-slot:filters>
                <ListFilter class="filter--main">
                    <input v-model="filters.query"
                        type="text"
                        placeholder="Rechercher dans les déstockages"/>
                </ListFilter>             
            </template>

            <template v-slot:checkboxActions>
                <button class="woocommerce-button button alt"
                    :disabled="processing || !itemSelected"
                    v-on:click="buy()">
                    <span class="fa fa-shopping-cart"></span>
                    Ajouter au panier
                </button>
            </template>

            <template v-slot:heading>                
                <div class="cell cell--cb">
                    <TogglerAll />
                </div>
                <div class="cell cell--ref">Réf.</div>
                <div class="cell cell--main">Produit</div>
                <div class="cell cell--variation">Unité de vente</div>
                <div class="cell cell--price">Prix HT</div>
                <div class="cell cell--actions">Actions</div>         
            </template>

            <ul class="list__content destockage" v-if="hasContent">

                <li v-for="category in categories"
                    :key="category.code">
                    
                    <collapse :hidden="false" :selected="true">

                        <div slot="collapse-header">

                            <div class="list__content__sublist">

                                <Category :data="category"/>

                            </div>
                        </div>

                        <div slot="collapse-body"> 
                            <ul class="list__content">

                                <li class="list__content__item"
                                    v-for="item in category.items"
                                    :key="item.id">

                                    <Article
                                        v-model="selectedItems"
                                        :variation="item" />

                                </li>

                            </ul>
                        </div>                            
                    
                    </collapse>

                </li>
                
            </ul>

            <div class="container_list container_list--no-result" v-else>
                <h1 class="woocommerce-order-details__title" v-show="!isFiltering">Aucun article</h1>
            </div>

            <div class="list__next" v-if="hasMore">
                <Loader v-if="isLoadingMore"></Loader>
                <button
                    class="button"
                    type="button"
                    @click="next"
                    v-else>Voir les articles suivants</button>
            </div>

        </List>

    </div>
</template>

<script>

import api from '@/api/proxyWeb/destockages'

import Article from '@/components/article/Article.vue'
import Button from '@/components/button/Button.vue'
import Category from '@/components/category/Category.vue'
import Collapse from '@/components/collapse/Collapse.vue'
import Loader from '@/components/loader/Loader.vue'
import List, { ListFilter, TogglerAll }  from '@/components/list/List.vue'

import cart from '@/containers/cart.vue'
import selectAll from '@/containers/selectAll.vue'
import filtering from "@/containers/filtering";

import  { useCategories } from '@/helpers/category';

export default {

    name: 'Destockage',

    data: () => {
        return {
            filters: {
                query: ''
            },
            uncategorizedItems: [],
            processingXlsx: false
        }
    },

    computed: {

        categories: function() {


            this.items.forEach(item => {
                if ( item.isPurchasable ) {
                    this.selectableItems.push(item)
                }
            })

            return useCategories(this.items);

        }       
  
    },

    methods: {

        buy() {

            let articles = this.selectedItems.map(item => {
                    return {
                        'id': item.article.id,
                        'quantity': 1,
                        'variationId': item.id
                    }
                })

            this.addToCart(articles);
        },

        downloadXlsx() {
            this.processingXlsx = true
            api.getXlsx(this.params)
                .then(() => { this.$notify.success('Téléchargement en cours...') })
                .finally(() => { this.processingXlsx = false } )
        },           
    },
  
    created () {

        this.useFilter(api)

    },

    watch:{


        isFiltering: function() {

            this.selectableItems = []

            this.items.forEach(item => {

                if ( item.isPurchasable ) {
                    this.selectableItems.push(item)
                }
            })
        }
    },

    components: {
        Article,
        Button,
        Category,
        Collapse,        
        List,
        ListFilter,
        Loader,
        TogglerAll
    },

    mixins: [
        cart,
        filtering,
        selectAll
    ]
}
</script>

<style>

.destockage .collapse .collapse-header::after {
  top: calc(50% - 0.2em);
}

</style>

<style scoped>

.destockage .destockage__filter {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
}

.destockage .destockage__filter > * {
    width: 30rem;
}

.cell.cell--ref {
    flex: 0.7;
}

.cell.cell--lists {
    flex: 1;
}
.cell.cell--variation {
    flex: 0.8;
}
.list__content__sublist {
    width: 100%;
}
</style>
